export default __webpack_public_path__ + "static/media/area-74.68616155.jpg";